import { gql } from '@apollo/client'

// mutation name added
export default gql(`
    mutation updateVirtualProgram($id: ID! $channelId: ID $startTime: AWSDateTime! $endTime: AWSDateTime $module: String) {
        updateVirtualProgram(
                input:{
                    id: $id
                    channel: $channelId,
                    broadCastStartTime: $startTime
                    broadCastEndTime: $endTime
                    source:"MANUAL"
                    isFirstRun:false
                    isLiveTelecast:false
                }
                module : $module
              ) {
                id
                source
                isLiveTelecast
                channel{
                    id
                    name
                    icon{
                        id
                        fileName
                        aspectRatio {
                            aspectRatio
                            ratio
                            title          
                            resolutions {
                            url
                            }
                        }
                        settings {
                            aspectRatio
                            outputFormat
                            fileName
                            x1
                            y1
                            x2
                            y2
                        }
                    }
                    masterConfig{
                        id
                    }
                    configGroups{
                        id
                        name
                        streams{
                            url
                            fields{
                                name
                                value
                                isRequired
                                type
                            }
                            streamSchema{
                                id
                                levels{
                                    id
                                    name
                                }
                            }
                        }
                    }
                    activeConfigGroup{
                        id
                        name
                        streams{
                            url
                            fields{
                                name
                                value
                                isRequired
                                type
                            }
                            streamSchema{
                                id
                                levels{
                                    id
                                    name
                                }
                            }
                        }
                    }
                    defaultTrimStart
                    defaultTrimEnd
                }
                broadCastStartTime
                broadCastEndTime
        }
    }`
)
